// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"41c585d3","785":"bac23200","819":"71a21d05","975":"49294a55"}[chunkId] + ".chunk.js";
};